// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__1VAPB","strip":"button_strip__1Xm0S","container":"button_container__21Mnr"};